package diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme

import androidx.compose.runtime.Immutable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Spacing tokens — 8px grid, base unit 4 (docs/DESIGN_SYSTEM.md). Access via `AppTheme.spacing`.
 */
@Immutable
data class AppSpacing(
    val xxs: Dp = 2.dp,
    val xs: Dp = 4.dp,
    val sm: Dp = 8.dp,
    val md: Dp = 12.dp,
    val lg: Dp = 16.dp,
    val xl: Dp = 24.dp,
    val xxl: Dp = 32.dp,
    val xxxl: Dp = 48.dp,
    val xxxxl: Dp = 64.dp,
    val containerMarginMobile: Dp = 16.dp,
    val containerMarginDesktop: Dp = 48.dp,
    val gutter: Dp = 16.dp,
    val sectionGap: Dp = 32.dp,
)

val appSpacing: AppSpacing = AppSpacing()
